import {
  FTSWidgetActions,
  FTSWidgetActionTypes,
  IApplicantData,
} from './actions'

export interface IFTSWidgetState {
  isFetching: boolean
  wizardKey: string
  transactionId: string
  requestError: Error | null
  transactionLocalData: IApplicantData
}

export const initialFTSWidgetState: IFTSWidgetState = {
  isFetching: false,
  wizardKey: '',
  transactionId: '',
  requestError: null,
  transactionLocalData: {
    personId: '',
    origin: '',
  },
}

export const FTSWidgetReducer = (
  state: IFTSWidgetState,
  action: FTSWidgetActions,
): IFTSWidgetState => {
  switch (action.type) {
    case FTSWidgetActionTypes.FTS_WIDGET_FIELD_CHANGE: {
      return {
        ...state,
        ...action.payload,
      }
    }

    case FTSWidgetActionTypes.SET_FTS_WIDGET_TRANSACTION_DATA: {
      return {
        ...state,
        transactionLocalData: {
          ...state.transactionLocalData,
          ...action.payload,
        },
      }
    }

    default: {
      return state
    }
  }
}
